"use strict";

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function () {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);

  __setModuleDefault(result, mod);

  return result;
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SnackbarConsumer = exports.SnackbarContext = void 0;

const react_1 = __importStar(require("react"));

const uuid_1 = require("uuid");

const AnimatedSnackbarContainer_1 = __importDefault(require("../components/animated-snackbar-container/AnimatedSnackbarContainer"));

const Timer_1 = __importDefault(require("../utils/Timer"));

exports.SnackbarContext = react_1.createContext({
  addSnackbar: () => {
    console.warn('addSnackbar was called without a <SnackbarProvider>.');
    return undefined;
  },
  removeSnackbar: () => {
    console.warn('removeSnackbar was called without a <SnackbarProvider>.');
  }
});

const SnackbarProvider = _a => {
  var {
    autoDismiss = 5000,
    container: Container = AnimatedSnackbarContainer_1.default
  } = _a,
      props = __rest(_a, ["autoDismiss", "container"]);

  const [snackbars, setSnackbars] = react_1.useState([]);

  const addSnackbar = (snackbar, options) => {
    var _a, _b;

    const id = (_a = options === null || options === void 0 ? void 0 : options.id) !== null && _a !== void 0 ? _a : uuid_1.v4();
    const entryAutoDismiss = (_b = options === null || options === void 0 ? void 0 : options.autoDismiss) !== null && _b !== void 0 ? _b : autoDismiss;
    const timer = entryAutoDismiss !== false ? new Timer_1.default(() => {
      removeSnackbar(id);
    }, entryAutoDismiss) : undefined;
    setSnackbars(snackbars => [{
      id,
      snackbar: typeof snackbar === 'function' ? snackbar({
        id
      }) : snackbar,
      timer
    }, ...snackbars]);
    return id;
  };

  const removeSnackbar = id => {
    setSnackbars(snackbars => {
      return snackbars.filter(entry => {
        if (entry.id === id && entry.timer) {
          entry.timer.stop();
        }

        return entry.id !== id;
      });
    });
  };

  return react_1.default.createElement(exports.SnackbarContext.Provider, {
    value: {
      addSnackbar,
      removeSnackbar
    }
  }, react_1.default.createElement(Container, null, snackbars.map(entry => react_1.cloneElement(entry.snackbar, {
    key: entry.id,
    id: entry.id,
    timer: entry.timer
  }))), props.children);
};

exports.default = SnackbarProvider;
exports.SnackbarConsumer = exports.SnackbarContext.Consumer;